import { useEffect, forwardRef, ForwardRefRenderFunction, ForwardedRef } from 'react';
import { Portal } from '@vfit/shared/components';
import { Modal } from '@vfit/shared/atoms';
import { OverlayGlobalStyle, WrapperOverrideStyle } from './vfModal.style';
import { IVfModalProps } from './vfModal.models';
import { CloseBtnHandle } from '../ModalWrappers/interfaces';

// const VfModal = ({
//   isOpen,
//   handleClose,
//   height,
//   children,
//   tabletMode,
//   customFooter,
//   wrapperId,
//   isDisabledClose,
//   isModalFullContainer,
//   enableCloseClickOutside,
//   closeColor,
//   variant = 'sunrise',
//   dataName, // for automation testing
// }: IVfModalProps) => {
const VfModalWithRef: ForwardRefRenderFunction<CloseBtnHandle, IVfModalProps> = (
  {
    isOpen,
    handleClose,
    height,
    children,
    tabletMode,
    customFooter,
    wrapperId,
    isDisabledClose,
    isModalFullContainer,
    enableCloseClickOutside,
    closeColor,
    variant = 'sunrise',
    dataName, // for automation testing
  }: IVfModalProps,
  ref: ForwardedRef<CloseBtnHandle>
) => {
  useEffect(() => {
    const closeOnEscapeKey = (e: KeyboardEvent) => (e.key === 'Escape' ? handleClose?.() : null);
    document.body.addEventListener('keydown', closeOnEscapeKey);
    return () => {
      document.body.removeEventListener('keydown', closeOnEscapeKey);
    };
  }, [handleClose]);

  return isOpen ? (
    <Portal wrapperId="coverage-tool">
      <WrapperOverrideStyle wrapperId={wrapperId}>
        <OverlayGlobalStyle />
        <Modal
          customId={wrapperId}
          withBorderRadius
          show={isOpen}
          onCloseModal={handleClose}
          isDisabledClose={isDisabledClose}
          height={height}
          tabletMode={tabletMode}
          isModalFullContainer={isModalFullContainer}
          enableCloseClickOutside={enableCloseClickOutside}
          closeColor={closeColor}
          variant={variant}
          dataName={dataName}
          ref={ref}
        >
          {children}
          {customFooter && customFooter()}
        </Modal>
      </WrapperOverrideStyle>
    </Portal>
  ) : null;
};

const VfModal = forwardRef<CloseBtnHandle, IVfModalProps>(VfModalWithRef);
export default VfModal;

